import {BaseContainerModel} from '../base-container.model';

export class MrpProcessInstanceHdrOrderByLvlDto extends BaseContainerModel {
    job_order_no: string;
    process_type: string;
    machine_code: string;
    output_item_code: string;
    output_item_name: string;
    qty_planned: number;
    uom: string;
    reverse_level_int: number;
    sequence_no: number;
    parent_guid: string;
    status: string;
    completion_date: string;
    is_active: boolean;
}